import type { ReactElement } from "react";
import type { ResourceArticle } from "../types";
import { ArrowIcon } from "./ArrowIcon";

interface ArticleCardProps {
  article: ResourceArticle;
}

export const ArticleCard = ({ article }: ArticleCardProps): ReactElement => (
  <a aria-label={`Read: ${article.title}`} className="resource-article-card" href={article.href}>
    <span className="resource-article-card__image">
      {article.imageSrc ? <img alt={article.imageAlt || `${article.title} guide`} src={article.imageSrc} /> : <span aria-hidden="true" />}
    </span>
    <span className="resource-article-card__body">
      <p className="resources-eyebrow">{article.eyebrow}</p>
      <h3>{article.title}</h3>
      <p>{article.description}</p>
      {(article.publishedAt || article.readTime) && (
        <small>{[article.publishedAt, article.readTime].filter(Boolean).join(" · ")}</small>
      )}
      <span className="resource-article-card__link">
        Read guide <ArrowIcon size={16} />
      </span>
    </span>
  </a>
);
